<template>
  <div class="vertical-align-wrap">
    <div class="vertical-align-middle auth-main h-100 d-flex">
      <div
        class="d-flex align-items-center justify-content-center w-100"
        style="background-color: oklch(98.4% 0.003 247.858)"
      >
        <div class="auth-box shadow-md">
          <div class="top d-flex justify-content-center my-2">
            <img
              src="../../../assets/logo6.png"
              alt="Lucid"
              style="width: 50px"
            />
            <link
              href="https://fonts.googleapis.com/css2?family=Lato:wght@400&display=swap"
              rel="stylesheet"
            />
            <span
              style="
                margin-top: 19px;
                margin-left: -9px;
                color: #273061;
                display: inline-block;
                font-family: 'Lato', sans-serif;
                font-size: 20px;
              "
              >FaceScreen</span
            >
          </div>
          <div class="card shadow-lg">
            <div class="header" v-if="!show2FAInput">
              <p class="lead fw-bold text-center">Login to your account</p>
            </div>
            <div class="body">
              <form class="form-auth-small" v-on:submit.prevent="submit">
                <div v-if="!show2FAInput">
                  <div class="form-group">
                    <label for="signin-email" class="control-label"
                      >Email</label
                    >
                    <input
                      type="email"
                      class="form-control"
                      id="signin-email"
                      v-model="username"
                      placeholder="Email"
                      required
                    />
                  </div>
                  <div class="form-group">
                    <label for="signin-password" class="control-label"
                      >Password</label
                    >
                    <input
                      type="password"
                      class="form-control"
                      id="signin-password"
                      v-model="password"
                      placeholder="Password"
                      required
                    />
                  </div>
                  <button
                    type="submit"
                    class="btn btn-primary btn-lg btn-block"
                  >
                    LOGIN
                  </button>
                </div>
                <!-- 2FA FIELDS -->
                <div v-if="show2FAInput" class="form-group -p-3">
                  <p
                    style="
                      font-weight: bold;
                      font-size: 18px;
                      margin-bottom: 8px;
                      text-align: center;
                    "
                  >
                    Verify your email
                  </p>
                  <p
                    style="
                      font-weight: normal;
                      font-size: 14px;
                      margin-bottom: 16px;
                      text-align: center;
                    "
                  >
                    Enter the verification code sent to your email:
                  </p>
                  <div class="otp-inputs">
                    <input
                      v-for="(digit, index) in otpDigits"
                      :key="index"
                      type="text"
                      maxlength="1"
                      class="otp-input"
                      v-model="otpDigits[index]"
                      @input="focusNext(index, $event)"
                      @keydown.backspace="focusPrev(index, $event)"
                    />
                  </div>
                  <button
                    class="btn btn-success btn-block mt-2"
                    @click.prevent="verify2FA"
                  >
                    Verify Code
                  </button>
                  <p class="resend-code">
                    Didn’t receive a code?
                    <span
                      class="resend-link"
                      :style="{
                        color: resendActive ? '#007bff' : 'gray',
                        cursor: resendActive ? 'pointer' : 'not-allowed',
                      }"
                      @click="resendCode"
                    >
                      Resend code
                      <span v-if="!resendActive"
                        >({{
                          String(Math.floor(resendTimer / 60)).padStart(2, "0")
                        }}:{{
                          String(resendTimer % 60).padStart(2, "0")
                        }})</span
                      >
                    </span>
                  </p>
                </div>

                <!-- success or error message -->
                <div
                  v-if="statusMessage.show"
                  :class="statusMessage.class"
                  class="alert-message"
                >
                  <i :class="statusMessage.icon_class"></i>
                  <div class="message-content">
                    {{ statusMessage.icon_title }}
                  </div>
                </div>
                <div class="bottom" v-if="!show2FAInput">
                  <span class="helper-text m-b-10"
                    ><i class="fa fa-lock" mr-1></i>
                    <router-link
                      to="/authentication/page-forgot-password"
                      class="ml-1"
                      >Forgot password?</router-link
                    ></span
                  >
                  <span
                    >Don't have an account?
                    <router-link to="/authentication/page-register"
                      >Register</router-link
                    ></span
                  >
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- footer logos -->
    <div class="footer-logos">
      <img
        v-for="(logo, i) in footerLogos"
        :key="i"
        :src="logo"
        :alt="`logo-${i + 1}`"
        :class="[
          'footer-logo',
          {
            'footer-logo-large': i === 2,
            'footer-logo-shift': i === 0 || i === 1,
          },
        ]"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "LoginComponent",
  data() {
    return {
      username: "",
      password: "",
      twoFACode: "",
      show2FAInput: false,
      otpDigits: ["", "", "", "", "", ""],
      userEmailFor2FA: "",
      statusMessage: {
        class: "",
        icon_class: "",
        icon_title: "",
        show: false,
      },
      footerLogos: [
        require("@/assets/Picture1.jpg"),
        require("@/assets/Picture2.png"),
        require("@/assets/Picture3.png"),
      ],
      resendTimer: 120,
      resendActive: false,
      timerInterval: null,
    };
  },
  methods: {
    beforeDestroy() {
      if (this.timerInterval) clearInterval(this.timerInterval);
    },

    async submit() {
      const fasdBackendURL = process.env.VUE_APP_BACKEND_URL;
      if (!fasdBackendURL) {
        throw new Error(
          "Backend URL not found in the environment configuration!"
        );
      }
      const url = `${fasdBackendURL}/api/users/login/token/`;
      localStorage.setItem("fasdBackendURL", fasdBackendURL);

      const timeoutPromise = (ms) =>
        new Promise((_, reject) =>
          setTimeout(
            () => reject(new Error("Backend failed to respond in time!")),
            ms
          )
        );

      try {
        const response = await Promise.race([
          fetch(url, {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: `username=${encodeURIComponent(
              this.username
            )}&password=${encodeURIComponent(this.password)}`,
          }),
          timeoutPromise(10000),
        ]);
        const data = await response.json();

        if (!response.ok) {
          const backendErrorMessage =
            data.detail || "An error occurred. Please try again.";
          this.statusMessage = {
            class: "alert alert-danger mt-3",
            icon_class: "fa fa-times-circle",
            icon_title: `Login failed! ${backendErrorMessage}`,
            show: true,
          };
          return;
        }

        setTimeout(() => {
          this.statusMessage.show = false;
        }, 3000);

        // 2FA required
        if (data.require_2fa) {
          this.show2FAInput = true;
          this.userEmailFor2FA = data.email;
          this.statusMessage = {
            class: "alert alert-success",
            icon_class: "fa fa-envelope",
            icon_title: "A verification code was sent to your email.",
            show: true,
          };
          return;
        }
        if (data.access_token) {
          localStorage.setItem("userJWtoken", data.access_token);
          this.statusMessage = {
            class: "alert alert-success",
            icon_class: "fa fa-check-circle",
            icon_title: "Authentication successful!",
            show: true,
          };

          setTimeout(() => {
            this.statusMessage.show = false;
          }, 3000);
        }
      } catch (error) {
        console.error("Something went wrong:", error);
        this.statusMessage = {
          class: "alert alert-danger",
          icon_class: "fa fa-times-circle",
          icon_title: `Login failed. ${error.message}`,
          show: true,
        };
      }
    },
    focusNext(index, event) {
      if (event.target.value && index < this.otpDigits.length - 1) {
        const nextInput = event.target.nextElementSibling;
        if (nextInput) {
          nextInput.focus();
        }
      }
    },
    focusPrev(index, event) {
      if (!event.target.value && index > 0) {
        const prevInput = event.target.previousElementSibling;
        if (prevInput) {
          prevInput.focus();
        }
      }
    },
    startResendTimer() {
      this.resendActive = false;
      this.resendTimer = 120; // reset timer to 2 minutes
      if (this.timerInterval) clearInterval(this.timerInterval);
      this.timerInterval = setInterval(() => {
        if (this.resendTimer > 0) {
          this.resendTimer--;
        } else {
          this.resendActive = true;
          clearInterval(this.timerInterval);
        }
      }, 1000);
    },
    async resendCode() {
      if (!this.resendActive) return;
      try {
        const fasdBackendURL = process.env.VUE_APP_BACKEND_URL;
        await fetch(`${fasdBackendURL}/api/users/login/resend-2fa`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email: this.userEmailFor2FA }),
        });
        this.statusMessage = {
          class: "alert alert-success",
          icon_class: "fa fa-envelope",
          icon_title: "A new verification code was sent to your email.",
          show: true,
        };
        this.startResendTimer();
      } catch (error) {
        this.statusMessage = {
          class: "alert alert-danger",
          icon_class: "fa fa-times-circle",
          icon_title: `Failed to resend code. ${error.message}`,
          show: true,
        };
      }
    },
    async verify2FA() {
      const fasdBackendURL = process.env.VUE_APP_BACKEND_URL;
      const code = this.otpDigits.join("");

      if (!code || code.length !== 6) {
        this.statusMessage = {
          class: "alert alert-danger",
          icon_class: "fa fa-times-circle",
          icon_title: "Please enter your 6-digit verification code.",
          show: true,
        };
        return;
      }

      try {
        const response = await fetch(`${fasdBackendURL}/api/users/login/2fa`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email: this.userEmailFor2FA,
            code: code,
          }),
        });

        if (!response.ok) {
          let errorData;
          try {
            errorData = await response.json();
          } catch (err) {
            errorData = { detail: "Invalid server response." };
          }

          this.statusMessage = {
            class: "alert alert-danger",
            icon_class: "fa fa-times-circle",
            icon_title: errorData.detail || "Invalid verification code.",
            show: true,
          };
          return;
        }

        const data = await response.json();

        if (!data.access_token) {
          this.statusMessage = {
            class: "alert alert-danger",
            icon_class: "fa fa-times-circle",
            icon_title: "Verification failed. No access token received.",
            show: true,
          };
          return;
        }

        localStorage.setItem("userJWtoken", data.access_token);
        this.statusMessage = {
          class: "alert alert-success",
          icon_class: "fa fa-check-circle",
          icon_title: "Verification successful!",
          show: true,
        };

        setTimeout(() => {
          this.statusMessage.show = false;
        }, 5000);

        setTimeout(() => {
          this.$router.push({ path: "/dashboard" });
        }, 2000);
      } catch (error) {
        console.error("2FA error:", error);
        this.statusMessage = {
          class: "alert alert-danger",
          icon_class: "fa fa-times-circle",
          icon_title: `Verification failed. ${error.message}`,
          show: true,
        };
      }
    },
  },
  watch: {
    show2FAInput(newVal) {
      if (newVal) {
        this.startResendTimer();
      }
    },
  },
};
</script>

<style scoped>
.alert-message {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  padding: 10px;
  margin-bottom: 15px;
  border-radius: 4px;
  font-size: 14px;
  gap: 4px;
}

.alert-message.alert {
  width: auto;
  margin: 0 auto;
  padding: 10px;
  box-sizing: border-box;
}

.alert-success {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
  display: flex;
  align-items: center;
}

.alert-success .fa,
.alert-success i {
  color: #155724;
}

.alert-danger {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
  display: flex;
  align-items: center;
}

.alert-danger .fa {
  color: #721c24;
}

.message-content {
  display: inline-block;
}

.vertical-align-wrap {
  min-height: 100vh;
}

.footer-logos {
  position: absolute;
  bottom: 20px;
  left: 0;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1.5rem;
}
.footer-logo {
  height: 50px;
  width: auto;
  object-fit: contain;
}
.footer-logo-large {
  height: 70px;
}
.footer-logo-shift {
  margin-top: 10px;
}
.otp-inputs {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin: 20px 0;
}
.otp-input {
  width: 45px;
  height: 45px;
  text-align: center;
  font-size: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
  transition: border-color 0.2s;
}

.otp-input:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 3px rgba(0, 123, 255, 0.5);
}
.resend-code {
  font-size: 14px;
  margin-top: 10px;
  text-align: center;
}

.resend-link {
  color: #007bff;
  cursor: pointer;
  text-decoration: underline;
  margin-left: 5px;
}

.resend-link:hover {
  text-decoration: none;
}
</style>
